import { Component, HostBinding } from '@angular/core';

@Component({
    selector: 'lui-card-doc-actions',
    template: ` <ng-content></ng-content> `,
    standalone: false
})
export class CardDocActionsComponent {
  @HostBinding('class') hostClass = 'lui-card-doc-actions';
}
